import React from 'react';

import { Title } from './styles';

import Project from '../../components/Project';

function Projects() {
	return (
		<>
			<Title>Projetos</Title>
			<Project />
			<Project />
			<Project />
		</>
	);
}

export default Projects;
